import {
    CORE_CREATE_ROLE_SUCCESS,
    CORE_CREATE_ROLE_REQUEST,

    CORE_EDIT_ROLE_SUCCESS,
    CORE_EDIT_ROLE_REQUEST,

    CORE_LOAD_ALL_ROLE_SUCCESS,
    CORE_LOAD_ALL_ROLE_REQUEST,

    CORE_LOAD_ROLE_SUCCESS,
    CORE_LOAD_ROLE_REQUEST,

    CORE_DELETE_ROLE_SUCCESS,
    CORE_DELETE_ROLE_REQUEST,

    CORE_FILTER_ROLE_REQUEST,
    CORE_FILTER_ROLE_SUCCESS,
} from '../../types'

const initialState = []
export default {
    role: (state = initialState, action) => {
        switch (action.type) {
            case CORE_CREATE_ROLE_REQUEST:
            case CORE_LOAD_ROLE_REQUEST:
            case CORE_EDIT_ROLE_REQUEST:
            case CORE_DELETE_ROLE_REQUEST:
                return initialState

            case CORE_CREATE_ROLE_SUCCESS:
            case CORE_LOAD_ROLE_SUCCESS:
            case CORE_EDIT_ROLE_SUCCESS:
            case CORE_DELETE_ROLE_SUCCESS:
                if (action.payload) {
                    return action.payload
                }
                else return {}

            default:
                return state
        }
    },
    rolesList:(state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_ALL_ROLE_REQUEST:
            case CORE_FILTER_ROLE_REQUEST:
                return initialState

            case CORE_LOAD_ALL_ROLE_SUCCESS:
            case CORE_FILTER_ROLE_SUCCESS:
                if (action.payload) {
                    return action.payload
                }
                else return [{}]

            default:
                return state
        }
    },

}


// WEBPACK FOOTER //
// ./src/features/roles/reducer.js